module.exports = __webpack_public_path__ + "static/media/level3Grey.0e3daaba.svg";